import { render, staticRenderFns } from "./ChangeDreg.vue?vue&type=template&id=51dc5783&"
import script from "./ChangeDreg.vue?vue&type=script&lang=js&"
export * from "./ChangeDreg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports